export default __webpack_public_path__ + "static/media/crown-red.74314552.png";